import { publicConfig } from "@/configs/public-config";
import { TokenService } from "@/providers/tokens/tokens.service";
import {
  fetchFileFromUrl,
  type IFetchFileFromUrlResult,
} from "@/shared/helpers/api-file-download.helper";

import type { IExportDistrictBoundaryZipArg } from "./districts.interface";

const DISTRICT_BOUNDARY_ZIP_FALLBACK = "district_boundary.zip";

export async function fetchDistrictBoundaryZip(
  arg: IExportDistrictBoundaryZipArg,
): Promise<IFetchFileFromUrlResult> {
  const { districtId } = arg;
  const url = `${publicConfig.apiUrl}/${publicConfig.apiTag}/districts/${districtId}/boundary/export/zip`;
  const accessToken = TokenService.getAccessToken();
  const headers: HeadersInit = accessToken
    ? { [publicConfig.authHeader]: `Bearer ${accessToken}` }
    : {};

  return fetchFileFromUrl(url, DISTRICT_BOUNDARY_ZIP_FALLBACK, { headers });
}
